/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { NavigationGuardNext, Route } from 'vue-router';
import { checkPermissions } from '../routeValidation';
const LiquidationsSummary = () =>
  import(
    /* webpackChunkName: "liquidations_liquidations_home" */
    '@/views/Liquidations/TransactionToLiquidate/Home.vue'
  );
const LiquidationsReport = () =>
  import(
    /* webpackChunkName: "liquidations_liquidations_home" */
    '@/views/Liquidations/Reports.vue'
  );
const LiquidationsDetailReport = () =>
  import(
    /* webpackChunkName: "liquidations_liquidations_home" */
    '@/views/Liquidations/Liquidations.vue'
  );
const LiquidationDetails = () =>
  import(
    /* webpackChunkName: "liquidations_liquidations_detail" */
    '@/views/Liquidations/TransactionToLiquidate/Detail.vue'
  );
const TransactionsLiquidated = () =>
  import(
    /* webpackChunkName: "transactions_liquidated" */
    '@/views/Liquidations/TransactionsLiquidated/Home.vue'
  );
const liquidationsPages = {
  path: '/',
  component: DashboardLayout,
  name: 'Liquidations',
  children: [
    {
      path: '/liquidations',
      name: 'liquidations-summary',
      component: LiquidationsSummary,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>): void {
        checkPermissions(to, from, next, 'index_liquidations');
      },
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/liquidations/:liquidation_id',
      name: 'liquidation-detail',
      component: LiquidationDetails,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>): void {
        checkPermissions(to, from, next, 'show_liquidations');
      },
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/transactionsPaid',
      name: 'transactions-liquidated',
      component: TransactionsLiquidated,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>): void {
        checkPermissions(to, from, next, 'index_liquidations');
      },
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/liquidations-report',
      name: 'transactions-report',
      component: LiquidationsReport,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>): void {
        checkPermissions(to, from, next, 'index_settlements_settlement');
      },
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/liquidations-report/:id',
      name: 'liquidation-report-list',
      component: LiquidationsDetailReport,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>): void {
        checkPermissions(to, from, next, 'index_settlements_liquidations');
      },
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default liquidationsPages;
